import React, { useState, useEffect } from 'react'
import { Table, TableBody, Paper, } from "@material-ui/core";
import { globalGetService, globalDeleteService } from '../../../utils/globalApiServices';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { ConfigureListing, ConfigureTableHeader, AddEditConfigure, ConfgureTab } from '../components';
import { checkApiStatus } from '../../../utils';
import { EmptyCollection, PageLoader, DeletePopUp } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { configureFilterOptions } from './index';
import { permissionCheckFnforCamo } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
import Pagination from '../../../shared_elements/components/Pagination';
import FleetCTA from '../../../shared_elements/components/FleetCTA';
import STabsLoader from '../../../shared_elements/components/skeleton_loader/STabsLoader';
function Configure({ match }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false)
    const [skeltonLoader, setSkeltonLoader] = useState(false)
    const [filter, setFilter] = useState()
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [deletelist, setDeleteList] = useState({ modal: false, data: null })
    const [data, setData] = useState({ list: [], pagination: {} })
    const [addEditConfig, setAddEditConfig] = useState({ modal: false, data: null, type: '' })
    const [egineFamily, setEngineFamily] = useState([])

    useEffect(() => {
        getConfigList({ per_page: 250 }, 'skeltonLoader')
        getEngineFamily()
        trackActivity('Disclaimer - Airworthiness Management', {
            event_type: 'Page Visited',
            page_title: 'Disclaimer Tab from Configure Section'
        });
    }, [])

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getConfigList({ ...sortQuery, per_page: 250 }, 'pageLoader');
    }


    const getConfigList = (query, loaderType) => {
        loaderType === "skeltonLoader" ? setSkeltonLoader(true) : setLoading(true)
        globalGetService(`camo/disclemer_revision/`, query)
            .then((response) => {
                loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
                if (checkApiStatus(response)) {
                    setData(response.data)
                    setFilter(query)
                }
            })
    }

    const deleteConfigList = () => {
        setLoading(true)
        globalDeleteService(`camo/disclemer_revision/${deletelist?.data?.id}/`)
            .then((response) => {
                setLoading(false); setDeleteList({ modal: false }); getConfigList({ per_page: 250 })
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Disclaimer - Airworthiness Management', {
                        event_type: 'Disclaimer Deleted Success',
                        page_title: 'Disclaimer Delete from Configure Section',
                        deleted_id: deletelist?.data?.id,
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Disclaimer - Airworthiness Management', {
                        event_type: 'Disclaimer Deleted Failed',
                        page_title: 'Disclaimer Delete from Configure Section',
                        deleted_id: deletelist?.data?.id,
                        error_msg: response?.data?.message
                    })
                }

            })
    }

    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }

    const filterObj = Object.assign({}, filter, delete filter?.per_page, delete filter?.page, delete filter?.sort, delete filter?.sort_by, delete filter?.asset_type)

    let filterOptions = Object.assign({}, configureFilterOptions);
    filterOptions = {
        ...filterOptions,
        engine_family: {
            ...filterOptions.engine_family,
            options: egineFamily
        },
    }

    const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;
    return (
        <>
            <DeploymentMessage />
            <ConfgureTab tabIndex="disclaimer" />
            <section className='camo-fleet-module'>
                {skeltonLoader ? <STabsLoader count={tabsLoaderCount} /> :
                    <FleetCTA
                        searchPlaceholder="Search By Revision Number Engine Family Engine Type"
                        onSearch={(value) => getConfigList({ search: value, per_page: 250 })}
                        permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" })}
                        addLabel="ADD CONFIGURE"
                        onAddFn={() => setAddEditConfig({ modal: true, data: null, type: 'add' })}
                        filterObj={filterObj}
                        filterOptions={filterOptions}
                        getResponseBack={(applyFilter) => getConfigList({ ...applyFilter, page: 1, per_page: 250 }, 'pageLoader')}
                    />}
                {skeltonLoader ? <STableLoader count={tabsLoaderCount} /> : <>
                    <Paper variant='outlined' square style={{ marginBottom: "5px" }}>
                        <div style={{ height: `${window.innerHeight - 270}px`, overflow: 'auto' }}>
                            <Table className='mui-table-format' stickyHeader={true}>
                                <ConfigureTableHeader
                                    createSortHandler={(sort) => createSortHandler(sort)}
                                    sortInfo={sortInfo}
                                />
                                <TableBody>
                                    {data?.results?.length > 0 && data?.results?.map((item, index) =>
                                        <ConfigureListing
                                            item={item}
                                            key={index}
                                            toggleModalFn={() => setAddEditConfig({ modal: true, data: item, type: 'edit' })}
                                            toggleDelteModalFn={() => setDeleteList({ modal: true, data: item })}
                                            onView={() => { setAddEditConfig({ modal: true, type: 'view', data: item }); trackActivity('Disclaimer View  - Airworthiness Management', { event_type: 'Disclaimer View mode', }) }}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                            {!data?.results?.length ? <EmptyCollection title="No Records Founds" /> : null}

                        </div>
                        <Pagination
                            pagination={data?.pagination}
                            onChangePage={(event, newPage) => getConfigList({ ...filter, page: newPage + 1, per_page: data?.pagination?.per_page || 250 }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getConfigList({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>
                </>}
                {addEditConfig.modal ?
                    <AddEditConfigure
                        configData={addEditConfig?.data}
                        modeType={addEditConfig?.type}
                        toggleModalFn={() => setAddEditConfig({ modal: false })}
                        getResponseBack={() => getConfigList({ per_page: 250, asset_type: 2 })}
                    /> : null
                }
                {deletelist.modal ?
                    <DeletePopUp
                        title='Delete Configure '
                        deleteRecordFn={() => deleteConfigList()}
                        modal={() => setDeleteList({ modal: true })}
                        content='Do you really want to delete this record?'
                        toggleModalFn={() => setDeleteList({ modal: false })}
                    /> : null

                }
                {isLoading ? <PageLoader /> : null}
            </section>
        </>
    )
}

export default withRouter(Configure)